import { render } from "./AuthSidebar.vue?vue&type=template&id=734e7007&scoped=true&ts=true"
import script from "./AuthSidebar.vue?vue&type=script&lang=ts"
export * from "./AuthSidebar.vue?vue&type=script&lang=ts"

import "./AuthSidebar.vue?vue&type=style&index=0&id=734e7007&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734e7007"]])

export default __exports__